import React, { useState } from 'react';
import {
    Container,
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    Box,
    TextField,
    Grid,
    Switch,
    FormControlLabel,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WarningIcon from '@mui/icons-material/Warning';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { can } from '../../Conections/LogConections';
import { useAuth } from '../../Auth/AuthProvider';
import { useNavigate, useParams } from 'react-router-dom';
import { DataGreenmodules, GetGreenHouseDataAPI, ListTermometers } from '../../Conections/GreenhouseConection';

// Datos de ejemplo para el grupo
let grupoEjemplo = {
    id: '',
    name: '',
    address: '',
    phone: '',
};

let modulos = [
    { id: '0', nombre: '', peso: 0, fecha: '', activa: true },
]

function GreenmoduleEdit() {

    const { getToken, getCompany } = useAuth();
    const goTo = useNavigate();
    const { id } = useParams();


    const [greenhouse, setGreenhouse] = useState(grupoEjemplo);
    const [greenmodulename, setGreenmodulename] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [estudianteARetirar, setEstudianteARetirar] = useState(null);
    const [actividadAEliminar, setActividadAEliminar] = useState(null);
    const [termometer, setTermometer] = useState([]);

    React.useEffect(() => {
        async function reloaduser() {
            if (getToken()) {
                const permisionCan = await can(getToken(), getCompany(), "/academic/showgroup/:id");
                if (permisionCan === 1) {
                    let GreenmoduleIn = await DataGreenmodules(getToken(), getCompany(), id);
                    let GreenhouseIn = await GetGreenHouseDataAPI(getToken(), getCompany(), GreenmoduleIn["greenhouseid"]);
                    let Termometers = await ListTermometers(getToken(), getCompany(), id);
                    setGreenhouse(GreenhouseIn);
                    setGreenmodulename(GreenmoduleIn["name"]);
                    setTermometer(Termometers);
                }
                else {
                    goTo("/dashboard");
                }
            }
            else {
                goTo(`/login`);
            }
        };
        reloaduser();
    }, [id, getCompany, getToken, goTo]);


    const handleCloseDialog = () => {
        setOpenDialog(false);
        setEstudianteARetirar(null);
        setActividadAEliminar(null);
    };

    const handleRetirarEstudiante = () => {
        console.log(`Retirando estudiante: ${estudianteARetirar?.nombre} ${estudianteARetirar?.apellido}`);
        handleCloseDialog();
    };

    const handleEliminarActividad = (actividad) => {
        setActividadAEliminar(actividad);
        setOpenDialog(true);
    };

    const confirmarEliminarActividad = () => {
        setGreenhouse(prevGrupo => ({
            ...prevGrupo,
            actividades: prevGrupo.actividades.filter(act => act.id !== actividadAEliminar.id)
        }));
        handleCloseDialog();
    };

    const handleEditarActividad = (actividad) => {
        goTo("/academic/editactivity/" + id + "/" + actividad.id);
    };

    const handleVerTermometro = (termometro) => {
        goTo("/greenhouse/showtermometer/" + termometro.id);
    };

    const handleAddTermometer = () => {
        goTo("/greenhouse/createtermometer/" + id);
    };

    const handleEditar = (id) => {
        goTo("/greenhouse/editgreenmodule/" + id);
    };

    return (
        <Container component="main" maxWidth="md">
            <Typography component="h1" variant="h4" gutterBottom sx={{ mt: 4, mb: 2 }}>
                Consulta de Modulo
            </Typography>

            <Grid container spacing={3}>
                {/* Tarjeta de Información del Grupo */}
                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            Información del Invernadero
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography>Nombre:
                                {greenhouse.name}
                            </Typography>
                            <Typography>Direccion: {greenhouse.address}</Typography>
                            <Typography>Telefono: {greenhouse.phone}</Typography>
                        </Box>
                    </Paper>
                </Grid>

                {/* Tarjeta de Información del Grupo */}
                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            Información del Modulo
                            <IconButton onClick={() => handleEditar(id)} color="primary">
                                <DriveFileRenameOutlineIcon />
                            </IconButton>
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography>Nombre: {greenmodulename}</Typography>
                        </Box>
                    </Paper>
                </Grid>

                {/* Tarjeta de Actividades del Grupo */}
                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Typography variant="h6" gutterBottom>Termometros
                            <IconButton color="primary" onClick={handleAddTermometer} sx={{ ml: 1 }}>
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </Typography>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Serial</TableCell>
                                        <TableCell>Estado</TableCell>
                                        <TableCell>MAC</TableCell>
                                        <TableCell align="center">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {termometer.map((termo) => (
                                        <TableRow key={termo.id}>
                                            <TableCell>{termo.serial}</TableCell>
                                            <TableCell>
                                                <FormControlLabel
                                                    control={<Switch checked={termo.enuso === 1} disabled />}
                                                    label={termo.enuso === 1 ? "En uso" : "Sin uso"}
                                                />
                                            </TableCell>
                                            <TableCell>{termo.mac}</TableCell>

                                            <TableCell align="center">
                                                <IconButton onClick={() => handleVerTermometro(termo)} color="primary">
                                                    <VisibilityIcon />
                                                </IconButton>
                                                {/*<IconButton onClick={() => handleEditarActividad(termo)} color="primary">
                                                    <EditIcon />
                                                </IconButton>
                                                <IconButton onClick={() => handleEliminarActividad(actividad)} color="secondary">
                                                    <DeleteIcon />
                                                </IconButton>*/}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>

            </Grid>

            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{ textAlign: 'center' }}
            >
                <DialogContent>
                    <WarningIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
                    <DialogTitle id="alert-dialog-title" sx={{ display: 'flex', alignItems: 'center' }}>
                        {estudianteARetirar
                            ? "¿Está seguro de retirar al estudiante del grupo?"
                            : "¿Está seguro de eliminar esta actividad?"}
                    </DialogTitle>
                    <DialogContentText id="alert-dialog-description">
                        {estudianteARetirar
                            ? `Esta acción retirará a ${estudianteARetirar?.nombre} ${estudianteARetirar?.apellido} del grupo.`
                            : `Esta acción eliminará la actividad "${actividadAEliminar?.nombre}" del grupo.`}
                        Esta acción no se puede deshacer.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button onClick={handleCloseDialog} variant="contained" color="primary">
                        Cancelar
                    </Button>
                    <Button
                        onClick={estudianteARetirar ? handleRetirarEstudiante : confirmarEliminarActividad}
                        variant="contained"
                        color="error"
                        autoFocus
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}

export default GreenmoduleEdit;

